





































import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbBtn, mdbAlert, mdbIcon, mdbTbl, mdbTblBody, mdbTimePicker, mdbSwitch } from '@folky-tools/mdbvue';
import { BusinessOpeningHours } from '@/models/businesses/business-opening-hours';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbBtn,
        mdbAlert,
        mdbIcon,
        mdbTbl,
        mdbTblBody,
        mdbTimePicker,
        mdbSwitch
    }
})
export default class EditOpeningHours extends Vue {
    @Prop(BusinessOpeningHours) private openingHours!: BusinessOpeningHours;
    @Prop({ type: Boolean, default: false }) private hasBusinessTimeSensitiveReferences!: boolean;
    private businessHoursTranslations: any = {};
    private isOpeningHoursActive: boolean = false;

    private beforeMount(): void {
        if (this.openingHours.schedule) {
            this.isOpeningHoursActive = true;
        }
        this.updateScheduleActivationStatus();
    }

    private mounted(): void {
        this.businessHoursTranslations = {
            switchOpen: this.$t('common.timetable.switchOpen'),
            switchClosed: this.$t('common.timetable.switchClosed'),
            placeholderOpens: this.$t('common.timetable.placeholderOpens'),
            placeholderCloses: this.$t('common.timetable.placeholderCloses'),
            addHours: this.$t('common.timetable.addHours'),
            open: {
                invalidInput: this.$t('common.timetable.open.invalidInput'),
                greaterThanNext: this.$t('common.timetable.open.greaterThanNext'),
                lessThanPrevious: this.$t('common.timetable.open.lessThanPrevious'),
                midnightNotLast: this.$t('common.timetable.open.midnightNotLast')
            },
            close: {
                invalidInput: this.$t('common.timetable.close.invalidInput'),
                greaterThanNext: this.$t('common.timetable.close.greaterThanNext'),
                lessThanPrevious: this.$t('common.timetable.close.lessThanPrevious'),
                midnightNotLast: this.$t('common.timetable.close.midnightNotLast')
            },
            t24hours: this.$t('common.timetable.t24hours'),
            midnight: this.$t('common.timetable.midnight'),
            days: {
                monday: this.$t('common.timetable.days.monday'),
                tuesday: this.$t('common.timetable.days.tuesday'),
                wednesday: this.$t('common.timetable.days.wednesday'),
                thursday: this.$t('common.timetable.days.thursday'),
                friday: this.$t('common.timetable.days.friday'),
                saturday: this.$t('common.timetable.days.saturday'),
                sunday: this.$t('common.timetable.days.sunday'),
                newYearsEve: this.$t('common.timetable.days.newYearsEve'),
                newYearsDay: this.$t('common.timetable.days.newYearsDay'),
                martinLutherKingJrDay: this.$t('common.timetable.days.martinLutherKingJrDay'),
                presidentsDay: this.$t('common.timetable.days.presidentsDay'),
                easter: this.$t('common.timetable.days.easter'),
                memorialDay: this.$t('common.timetable.days.memorialDay'),
                independenceDay: this.$t('common.timetable.days.independenceDay'),
                fourthOfJuly: this.$t('common.timetable.days.fourthOfJuly'),
                laborDay: this.$t('common.timetable.days.laborDay'),
                columbusDay: this.$t('common.timetable.days.columbusDay'),
                veteransDay: this.$t('common.timetable.days.veteransDay'),
                thanksgivingDay: this.$t('common.timetable.days.thanksgivingDay'),
                christmasEve: this.$t('common.timetable.days.christmasEve'),
                christmas: this.$t('common.timetable.days.christmas')
            }
        };
    }

    private switchScheduleActivation(): void {
        this.isOpeningHoursActive = !this.isOpeningHoursActive;

        this.updateScheduleActivationStatus();
    }

    private updateScheduleActivationStatus(): void {
        if (this.isOpeningHoursActive) {
            if (!this.openingHours.schedule) {
                const defaultScheduleData = {
                    monday: [
                        {
                            open: '',
                            close: '',
                            id: '5ca5578b0c5d1',
                            isOpen: false
                        }
                    ],
                    tuesday: [
                        {
                            open: '',
                            close: '',
                            id: '5ca5578b0c5d8',
                            isOpen: false
                        }
                    ],
                    wednesday: [
                        {
                            open: '',
                            close: '',
                            id: '5ca5578b0c5df',
                            isOpen: false
                        }
                    ],
                    thursday: [
                        {
                            open: '',
                            close: '',
                            id: '5ca5578b0c5e6',
                            isOpen: false
                        }
                    ],
                    friday: [
                        {
                            open: '',
                            close: '',
                            id: '5ca5578b0c5ec',
                            isOpen: false
                        }
                    ],
                    saturday: [
                        {
                            open: '',
                            close: '',
                            id: '5ca5578b0c5f8',
                            isOpen: false
                        }
                    ],
                    sunday: [
                        {
                            open: '',
                            close: '',
                            id: '5ca5578b0c5c7',
                            isOpen: false
                        }
                    ]
                };
                this.openingHours.schedule = defaultScheduleData;
            }
        } else {
            this.openingHours.schedule = null;
        }
        this.updatedHours(this.openingHours);
    }

    private updatedHours(val: any): void {
        this.$emit('update:openingHours', this.openingHours);
    }
}
